import { render, staticRenderFns } from "./S301.vue?vue&type=template&id=40f22066&scoped=true"
import script from "./S301.vue?vue&type=script&lang=js"
export * from "./S301.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=40f22066&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f22066",
  null
  
)

export default component.exports